<template>
  <div class="filter-section">
    <!-- 筛选条件区域 -->
    <div class="filter-content">
      <slot />
    </div>

    <!-- 操作按钮区域 -->
    <div class="filter-actions">
      <!-- 左侧：主要操作按钮 -->
      <div class="action-buttons">
        <a-button
          type="primary"
          size="small"
          class="search-button"
          @click="handleSearch"
        >
          检索
        </a-button>
        <a-button
          size="small"
          class="reset-button"
          @click="handleReset"
        >
          重置
        </a-button>
        <a-button
          size="small"
          class="advanced-button"
          @click="handleAdvancedSearch"
        >
          高级检索
        </a-button>
      </div>

      <!-- 右侧：展开/收起功能 -->
      <button
        v-if="showMore"
        class="toggle-more-button"
        @click="handleToggleMore"
      >
        {{ isMoreExpanded ? '收起' : '展开' }}
        <component :is="isMoreExpanded ? ChevronUp : ChevronDown" :size="16" />
      </button>
    </div>
  </div>
</template>

<script>
import { ChevronDown, ChevronUp } from 'lucide-vue-next'

export default {
  name: 'FilterSection',
  components: {
    ChevronDown,
    ChevronUp
  },
  props: {
    showMore: {
      type: Boolean,
      default: false
    },
    isMoreExpanded: {
      type: Boolean,
      default: false
    }
  },
  emits: ['search', 'reset', 'toggle-more', 'advanced-search'],
  methods: {
    handleSearch() {
      this.$emit('search')
    },
    handleReset() {
      this.$emit('reset')
    },
    handleAdvancedSearch() {
      this.$emit('advanced-search')
    },
    handleToggleMore() {
      this.$emit('toggle-more')
    }
  }
}
</script>

<style scoped>
.filter-section {
  background: #fff;
  border-radius: 4px;
  border: 1px solid #d9d9d9;
  margin-bottom: 16px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
  position: relative;
  z-index: 5;
}

/* 1366*768 和 pad 响应式优化 */
@media (max-width: 1366px) {
  .filter-content {
    padding: 16px 20px;
  }
  
  .filter-actions {
    padding: 12px 20px;
  }
}

@media (max-width: 1024px) {
  .filter-content {
    padding: 12px 16px;
  }
  
  .filter-actions {
    padding: 10px 16px;
    flex-wrap: wrap;
    gap: 8px;
  }
}

.filter-content {
  padding: 20px 24px;
}

.filter-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px;
  border-top: 1px solid #f0f0f0;
  background: #fafafa;
}

.action-buttons {
  display: flex;
  align-items: center;
  gap: 8px;
}

.search-button {
  padding: 0 24px;
  height: 32px;
  background: #1890ff;
  border: none;
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.045);
}

.search-button:hover {
  background: #40a9ff;
}

.search-button:active {
  background: #096dd9;
}

.reset-button {
  padding: 0 24px;
  height: 32px;
  border-color: #d9d9d9;
  color: rgba(0, 0, 0, 0.85);
}

.reset-button:hover {
  color: #1890ff;
  border-color: #1890ff;
}

.advanced-button {
  padding: 0 24px;
  height: 32px;
  border-color: #d9d9d9;
  color: rgba(0, 0, 0, 0.85);
}

.advanced-button:hover {
  color: #1890ff;
  border-color: #1890ff;
}

.toggle-more-button {
  display: flex;
  align-items: center;
  gap: 4px;
  color: #1890ff;
  font-size: 14px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 4px 8px;
  transition: color 0.3s;
}

.toggle-more-button:hover {
  color: #40a9ff;
}
</style>


